import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ProfilService {
  private fullNameSource = new BehaviorSubject<string>('');
  fullName$ = this.fullNameSource.asObservable();

  updateFullName(name: string): void {
    this.fullNameSource.next(name);
  }
}
